import React from "react";
import SvgEcgIcon from "../../../assets/svg/EcgIcon";
import SvgSpiroIcon from "../../../assets/svg/SpiroIcon";
import SvgStateIcon from "../../../assets/svg/StateIcon";
import SvgStethoscopeIcon from "../../../assets/svg/StethoscopeIcon";
import './StudyIcon.css';
import {useTranslation} from "react-i18next";

export enum StudyType {
    State,
    Ecg,
    Spiro,
    Stethoscope,
    LtEcg
}

export function studyViewSuffix(type: StudyType): string | null {
    switch (type) {
        case StudyType.Ecg:
            return "ecg";
        case StudyType.Spiro:
            return "spiro";
        case StudyType.Stethoscope:
            return "stethoscope";
        default:
            return null;
    }
}

interface StudyIconProps {
    type: StudyType;
    hasText?: boolean;
    isVisible: boolean;
    onClick: () => void;
    onContextMenu?: (anchorX: number, anchorY: number) => void;
}

export const StudyIcon: React.FC<StudyIconProps> = ({type, hasText = false, isVisible, onClick, onContextMenu}: StudyIconProps) => {
    const {t} = useTranslation();
    let icon;
    let text;
    switch (type) {
        case StudyType.State:
            icon = <SvgStateIcon/>;
            text = t("state");
            break;
        case StudyType.Ecg:
            icon = <SvgEcgIcon/>;
            text = t("ecg");
            break;
        case StudyType.Spiro:
            icon = <SvgSpiroIcon/>;
            text = t("spiro");
            break;
        case StudyType.Stethoscope:
            icon = <SvgStethoscopeIcon/>;
            text = t("stethoscope");
            break;
        case StudyType.LtEcg:
            icon = <SvgEcgIcon/>;
            text = t("lt_ecg");
            break;
        default:
            icon = null;
            text = "";
            break;
    }
    const clickHandler = (e: any) => {
        if (isVisible) {
            e.stopPropagation();
            onClick();
        }
    };
    const contextMenuHandler = (event: React.MouseEvent<HTMLDivElement>) => {
        if (!isVisible || !onContextMenu) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        onContextMenu(event.clientX, event.clientY);
    };
    return (
        <div className={`study-icon-container ${isVisible ? "" : "study-icon-hidden"}`} onClick={clickHandler}
             onContextMenu={onContextMenu ? contextMenuHandler : undefined}>
            {icon && icon}
            {(hasText && text) && <span className="no-select">{text}</span>}
        </div>
    );
}